import moment, { Moment } from 'moment';
import { message } from 'antd';

export const checkURL = (url: string) => url?.match(/\.(jpeg|jpg|gif|png)$/) != null;

export const getBase64 = (img: any, callback: any) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};

export const beforeFileUpload = (file: any): boolean => {
  const supportedFileType = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
  if (!supportedFileType) {
    message.error('You can only upload JPG/PNG/JPEG file!', 5);
    return false;
  }

  const fileSize = file.size / 1024 / 1024 < 5;
  if (!fileSize) {
    message.error('Image must smaller than 5MB!', 5);
    return false;
  }
  return true;
};

// TODO: not in use
export const calculateDueIn = (createdAt: string) => {
  const date1 = moment();
  const date2 = moment(createdAt);
  let dueTime = 'overdue';
  if (date1.diff(date2, 'minutes') < 60) {
    dueTime = `${date1.diff(date2, 'minutes')} mins`;
  } else if (date1.diff(date2, 'hours') > 0 && date1.diff(date2, 'hours') < 48) {
    dueTime = `${48 - date1.diff(date2, 'hours')} hrs`;
  } else if (date1.diff(date2, 'days') < 2) {
    dueTime = `${date1.diff(date2, 'days')} days`;
  }
  return dueTime;
};

export const formatDate = (date: string | undefined, fr: string) => moment(date).format(fr);

// TODO: not in use
export const roundDecimalNumber = (number: number) => {
  const roundOfNumber = Math.round(number * 10);
  return roundOfNumber / 10;
};

export const searchParams = (url: string, key: string): string | null => {
  try {
    const params = new URL(url)?.searchParams;
    return params?.get(key);
  } catch {
    return '';
  }
};

export const getDateStringWithoutTime = (date: Moment | Date | string) => moment(date).toISOString().split('T')[0];

export const camelCaseToText = (text: string) => {
  const result = text.replace(/([A-Z])/g, ' $1');
  const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
  return finalResult;
};

export const DEFAULT_AVATAR_SRC = 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png';

// TODO: FRON-3342 - Bharat
// export function duration(date: string) {
//   const d = new Date().valueOf() - new Date(date).valueOf();
//   const weekdays = Math.floor(d / 1000 / 60 / 60 / 24 / 7);
//   const days = Math.floor(d / 1000 / 60 / 60 / 24);
//   const hours = Math.floor(d / 1000 / 60 / 60 - weekdays * 7 * 24 - days * 24);
//   const minutes = Math.floor(d / 1000 / 60 - weekdays * 7 * 24 * 60 - days * 24 * 60 - hours * 60);
//   const seconds = Math.floor(
//     d / 1000 - weekdays * 7 * 24 * 60 * 60 - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60,
//   );
//   const milliseconds = Math.floor(
//     d -
//       weekdays * 7 * 24 * 60 * 60 * 1000 -
//       days * 24 * 60 * 60 * 1000 -
//       hours * 60 * 60 * 1000 -
//       minutes * 60 * 1000 -
//       seconds * 1000,
//   );

//   return {
//     weekdays: weekdays > 0 ? weekdays : undefined,
//     days: days > 0 ? days : undefined,
//     hours: hours > 0 ? hours : undefined,
//     minutes: minutes > 0 ? minutes : undefined,
//     seconds: seconds > 0 ? seconds : undefined,
//     milliseconds: milliseconds > 0 ? milliseconds : undefined,
//   };
// }

export const duration = (date: string) => {
  const S = 1000;
  const M = 60 * S;
  const H = 60 * M;
  const D = 24 * H;
  const W = 7 * D;

  const d = new Date().valueOf() - new Date(date).valueOf();

  const weekdays = Math.floor(d / W);
  const days = Math.floor(d / D);
  const hours = Math.floor((d % D) / H);
  const minutes = Math.floor((d % H) / M);
  const seconds = Math.floor((d % M) / S);
  const milliseconds = d % S;

  return { weekdays, days, hours, minutes, seconds, milliseconds };
};
